import { Baseurl } from "./url";
import { errorMessage } from "./apiError";
import { getToken } from "./authentication";


export const CLOCK_STATUS = {
    pending: { label: 'Awaiting approval', color: 'warning' },
    approved: { label: 'Live on the map', color: 'success' },
    rejected: { label: 'Not approved', color: 'error' },
};

const authHeaders = () => ({ 'Authorization': getToken() });


export async function submitClockRequest(fields, photos = []) {
    const body = new FormData();
    Object.entries(fields).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') body.append(key, value);
    });
    photos.forEach((photo) => body.append('photos', photo));

    
    const response = await fetch(`${Baseurl}/editors/clocks`, {
        method: 'POST',
        headers: authHeaders(),
        body: body
    });
    if (response.ok) {
        return { ok: true, clock: await response.json() };
    }
    console.error(`HTTP Error: ${response.status}`);
    return { ok: false, message: await errorMessage(response, "Sorry, we couldn't send that. Please try again.") };
}


export async function getMyClockRequests() {
    const response = await fetch(`${Baseurl}/editors/clocks`, { headers: authHeaders() });
    if (response.ok) {
        const clocks = await response.json();
        return { ok: true, clocks: Array.isArray(clocks) ? clocks : [] };
    }
    console.error(`HTTP Error: ${response.status}`);
    return { ok: false, message: "Sorry, we couldn't load your clocks." };
}


export async function fetchPhotoUrl(path) {
    try {
        const response = await fetch(`${Baseurl}${path}`, { headers: authHeaders() });
        if (!response.ok) return null;
        return URL.createObjectURL(await response.blob());
    } catch (e) {
        return null;
    }
}

export const requestPhotoPath = (photoId) => `/editors/clock-photos/${photoId}`;
